import SEO from '@/components/seo'
import Company from '@/views/company'

const CompanyPage = () => (
  <>
    <SEO
      title="運営会社"
      url="company"
      description="ONLIVE Studio はサウンドオンライブ株式会社が運営する、音楽のクリエイターと依頼者をつなぐマッチングサービスです。"
    />
    <Company />
  </>
)

export default CompanyPage
